import { USERS_ENDPOINTS } from '../../../utils/api/endpoints/usersEndpoints';
import { QueryUserInfosResponse } from './useUserInfos.types';

const PREFIX = '[userInfosQuery]';

export const queryUserInfos = async () => {
  console.log(PREFIX, `Fetching user infos...`);
  const response = await USERS_ENDPOINTS.infos();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user infos.`);
  return json as QueryUserInfosResponse;
};
